// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-pages-Project-ProductionManagement-Dashboards-DashboardHeader-___styles__container {
  display: flex;
  align-items: center;
  width: 100%;
  height: 75px;
}

.app-pages-Project-ProductionManagement-Dashboards-DashboardHeader-___styles__linkBtn {
  border: 1px solid black;
  border-radius: 4px;
  padding: 0 11px;
  height: 30px;
  font-size: 14px;
  font-weight: bold;
  color: var(--colors-greyDark);
  display: flex;
  align-items: center;
}

.app-pages-Project-ProductionManagement-Dashboards-DashboardHeader-___styles__linkBtn:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }

.app-pages-Project-ProductionManagement-Dashboards-DashboardHeader-___styles__saveBtn {
  display: flex;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./app/pages/Project/ProductionManagement/Dashboards/DashboardHeader/styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;AAKrB;;AAHE;IACE,qCAAqC;EACvC;;AAGF;EACE,aAAa;EACb,mBAAmB;AACrB","sourcesContent":[".container {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: 75px;\n}\n\n.linkBtn {\n  border: 1px solid black;\n  border-radius: 4px;\n  padding: 0 11px;\n  height: 30px;\n  font-size: 14px;\n  font-weight: bold;\n  color: var(--colors-greyDark);\n  display: flex;\n  align-items: center;\n\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.05);\n  }\n}\n\n.saveBtn {\n  display: flex;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `app-pages-Project-ProductionManagement-Dashboards-DashboardHeader-___styles__container`,
	"linkBtn": `app-pages-Project-ProductionManagement-Dashboards-DashboardHeader-___styles__linkBtn`,
	"saveBtn": `app-pages-Project-ProductionManagement-Dashboards-DashboardHeader-___styles__saveBtn`
};
export default ___CSS_LOADER_EXPORT___;
